var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{style:(_vm.styleColor),attrs:{"src":_vm.styleColor.videoAdress,"controls":"controls"}},[_vm._v(" 您的浏览器不支持 video 标签。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }